import { useTranslation } from 'react-i18next'

const CommonFallback = () => {
  const { t } = useTranslation()
  return <p>{t('common:fetching_data')}</p>
}

export default CommonFallback
